import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5 9C16.5 9.98491 16.306 10.9602 15.9291 11.8701C15.5522 12.7801 14.9997 13.6069 14.3033 14.3033C13.6069 14.9997 12.7801 15.5522 11.8701 15.9291C10.9602 16.306 9.98491 16.5 9 16.5C8.01509 16.5 7.03982 16.306 6.12987 15.9291C5.21993 15.5522 4.39314 14.9997 3.6967 14.3033C3.00026 13.6069 2.44781 12.7801 2.0709 11.8701C1.69399 10.9602 1.5 9.98491 1.5 9C1.5 7.01088 2.29018 5.10322 3.6967 3.6967C5.10322 2.29018 7.01088 1.5 9 1.5C10.9891 1.5 12.8968 2.29018 14.3033 3.6967C15.7098 5.10322 16.5 7.01088 16.5 9ZM11.9717 6.86166C11.7114 6.60131 11.2887 6.60131 11.0284 6.86166L8.16605 9.72396L6.97172 8.52865C6.71137 8.2683 6.28871 8.2683 6.02836 8.52865C5.76828 8.78891 5.76839 9.21071 6.02836 9.47104L7.69535 11.138C7.95565 11.3983 8.37737 11.3982 8.63773 11.138L11.9717 7.80502C12.2321 7.54467 12.2321 7.12201 11.9717 6.86166Z",
		fill: "currentColor"
	})
});
export default SvgCheckSolid;
